<!-- 写真图集 -->
<template>
  <div :class="$style.gallery">
    <lazy-component>
      <template v-if="dataSource.length > 0">
        <div :class="$style['gallery-wrapper']">
          <swiper
            ref="mySwiper"
            :options="swiperOptions"
            :class="$style['gallery-swiper']"
          >
            <swiper-slide v-for="(el, i) in dataSource" :key="i">
              <img :src="el.picture" />
            </swiper-slide>
          </swiper>
        </div>
        <!-- 左右切换按钮 -->
        <button
          :class="[$style['nav-btn'], $style['nav-btn-prev']]"
          @click="onPrev"
        />
        <button
          :class="[$style['nav-btn'], $style['nav-btn-next']]"
          @click="onNext"
        />
      </template>
    </lazy-component>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "TheGallery",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      swiperOptions: {
        loop: true
      }
    };
  },
  methods: {
    onPrev() {
      const { $swiper } = this.$refs.mySwiper;
      if ($swiper) $swiper.slidePrev();
    },
    onNext() {
      const { $swiper } = this.$refs.mySwiper;
      if ($swiper) $swiper.slideNext();
    }
  }
};
</script>

<style lang="less" module>
.gallery {
  .background-fill("./images/gallery-bg.jpg");

  position: relative;
  height: 7.79rem;
  padding-top: 2.18rem;

  &-wrapper {
    .size(8.86rem, 4.95rem);

    position: relative;
    margin: 0 auto;

    &::after {
      .size(9.6rem, 5.33rem);
      .background-fill("./images/gallery-border.png");

      z-index: 1;
      content: "";
      position: absolute;
      top: -0.16rem;
      left: -0.39rem;
      pointer-events: none;
    }
  }

  &-swiper {
    .size(100%);

    border-radius: 0.6rem;

    img {
      .size(100%);

      display: block;
      object-fit: cover;
    }
  }
}

.nav-btn {
  .size(0.69rem, 2.75rem);
  .background-fill("./images/gallery-btn.png");

  z-index: 1;
  position: absolute;
  top: 3.42rem;

  &-prev {
    left: 0.13rem;
    transform: rotate(180deg);
  }

  &-next {
    right: 0.13rem;
  }
}
</style>
